import request from '@/utils/request'

export function getSchoolList(params) {
  return request({
    url: '/admin/school/list',
    method: 'get',
    params
  })
}

// 学校下拉选项（不分页）。非超管只会拿到自己被授权的学校
export function getSchoolOptions() {
  return request({
    url: '/admin/school/options',
    method: 'get'
  })
}

export function createSchool(data) {
  return request({
    url: '/admin/school',
    method: 'post',
    data
  })
}

export function updateSchool(data) {
  return request({
    url: '/admin/school',
    method: 'put',
    data
  })
}

// 切换开通状态：0-筹备中（用户端不展示），1-试点中（展示+挂标），2-正式运营
export function updateSchoolLaunchStatus(id, launchStatus) {
  return request({
    url: '/admin/school/' + id + '/launch-status',
    method: 'put',
    data: { launchStatus }
  })
}

export function deleteSchool(id) {
  return request({
    url: '/admin/school/' + id,
    method: 'delete'
  })
}

export function getSchoolDetail(id) {
  return request({
    url: '/admin/school/' + id,
    method: 'get'
  })
}
